export default __webpack_public_path__ + "static/media/mojito-jahoda.40f0aa05.jpg";